export { DEMO_ENV_CONFIG } from './app-config';

export * from './lib/consumer-portal-demo.module';
export * from './lib/components/consumer-portal-demo/consumer-portal-demo.component';
export * from './app-config';
export * from './lib/models/env-file-model copy';
